var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const Scooter = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M8 17C8 15.3432 6.65685 14 5 14C3.34315 14 2 15.3432 2 17C2 18.6569 3.34315 20 5 20C6.65685 20 8 18.6569 8 17ZM8 17L16 17M8 17L5 17M15.5 4H11.5M15.5 4H19.5M15.5 4L19 17M16 17C16 18.6569 17.3431 20 19 20C20.6569 20 22 18.6569 22 17C22 15.3431 20.6569 14 19 14C17.3431 14 16 15.3432 16 17Z", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
